<template>
  <h1 class="mt-4">This Login Page</h1>
</template>

<script>
export default {
  created() {
    localStorage.setItem("access_token", this.$route.query.token);
    location.replace("/");
  },
};
</script>